import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { cteAPI } from 'services/apiRest';
import { actions as toastrActions } from 'react-redux-toastr';
import { Container, WrapperButtons, WrapperInput, FileInput } from './styles';

function ModalImportarXml({ open, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [xmlContent, setXmlContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = (event) => {
        setXmlContent(event.target.result);
      };
      reader.readAsText(selectedFile);
    }
  };

  const handleSubmit = async () => {
    if (!xmlContent.trim()) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Por favor, selecione ou cole o XML',
        })
      );
      return;
    }

    setLoading(true);
    try {
      const resultado = await cteAPI.processarXml(xmlContent);
      
      dispatch(
        toastrActions.add({
          type: 'success',
          title: 'Sucesso',
          message: 'XML processado com sucesso!',
        })
      );

      if (onSuccess) {
        onSuccess(resultado);
      }
      
      handleClose();
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro ao processar XML',
          message: error.message || 'Erro desconhecido',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setXmlContent('');
    setFile(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Importar XML e Gerar CT-e">
      <Container>
        <WrapperInput>
          <FileInput>
            <input
              type="file"
              accept=".xml"
              onChange={handleFileChange}
              style={{ marginBottom: '10px' }}
            />
            <span>ou cole o XML abaixo:</span>
          </FileInput>
        </WrapperInput>

        <WrapperInput>
          <TextField
            label="Conteúdo do XML"
            name="xmlContent"
            value={xmlContent}
            onChange={(e) => setXmlContent(e.target.value)}
            multiline
            rows={15}
            fullWidth
            placeholder="Cole o conteúdo do XML aqui ou selecione um arquivo..."
          />
        </WrapperInput>

        <WrapperButtons>
          <Button
            label="Cancelar"
            onClick={handleClose}
            color="secondary"
            margin="0 10px 0 0"
            disabled={loading}
          />
          <Button
            label={loading ? 'Processando...' : 'Processar XML'}
            onClick={handleSubmit}
            color="primary"
            disabled={loading || !xmlContent.trim()}
          />
        </WrapperButtons>
      </Container>
    </Modal>
  );
}

export default ModalImportarXml;

